import React from 'react'
import './App.css'
import 'antd/dist/antd.css'
import { Layout } from 'antd'
import Routes from './Routes'

function App() {
  return (
    <Layout>
      <Routes/>
    </Layout>
  )
}

export default App
